export default __webpack_public_path__ + "static/media/a038-3.49c6bb97.svg";